import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEffect = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9.95981 5.49005L12.0298 6.32006C12.5698 6.54006 12.5698 6.89004 12.0298 7.11004L9.95981 7.94006L9.12981 10.02C8.90981 10.54 8.55981 10.54 8.33981 10.02L7.5098 7.94006L5.4398 7.11004C4.9198 6.89004 4.9198 6.54006 5.4398 6.32006L7.5098 5.49005L8.33981 3.41006C8.55981 2.86006 8.90981 2.86006 9.12981 3.41006L9.95981 5.49005Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.5199 11.8401L19.5899 12.6702C20.1299 12.8902 20.1299 13.2401 19.5899 13.4601L17.5199 14.2902L16.6899 16.3701C16.4699 16.8901 16.1199 16.8901 15.8999 16.3701L15.0699 14.2902L12.9999 13.4601C12.4799 13.2401 12.4799 12.8902 12.9999 12.6702L15.0699 11.8401L15.8999 9.76016C16.1199 9.21016 16.4699 9.21016 16.6899 9.76016L17.5199 11.8401Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.21 16.78L9.99 17.49C10.46 17.68 10.46 17.98 9.99 18.17L8.21 18.88L7.5 20.66C7.31 21.11 7.01 21.11 6.82 20.66L6.11 18.88L4.33 18.17C3.89 17.98 3.89 17.68 4.33 17.49L6.11 16.78L6.82 15C7.01 14.53 7.31 14.53 7.5 15L8.21 16.78Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgEffect;
